import React, { useState, useEffect } from 'react';
import { Select, DatePicker, Button, Icon } from 'antd';

import moment, { duration } from 'moment';

const { Option } = Select
const { RangePicker } = DatePicker;

function FuelReportInfo(props) {
    const [isCustomRange, setIsCustomRange] = useState(false);
    const [durationRange, setDurationRange] = useState([]);
    const [groupName, setgroupName] = useState('d');
    const [periodProcessing, setPeriodProcessing] = useState(false);

    // useEffect(() => {
    //     console.log(props.selectedValue, props.selectedGroup);
    // }, [props.selectedValue, props.selectedGroup]);

    useEffect(() => {
        calculateDurationRange('7d', true);
    }, [props.hasFuelSensor]);

    const handleSelectDurationChange = (duration) => {
        props.handleOnChange(duration);
        if (!duration || duration === '0')
            setIsCustomRange(true)
        else {
            setIsCustomRange(false)
            calculateDurationRange(duration);
        }
    }

    const handleGroupChange = (group) => {
        // console.log(group);
        // console.log(props);
        // handleDataGroup={handleDataGroup} selectedGroup={selectedGroup}
        setgroupName(group)
    }

    const processChangedGroup = (group) => {
        if (props.handleDataGroup)
            props.handleDataGroup(group)
    }

    const calculateDurationRange = (duration, callFunction = false) => {
        const now = moment().subtract(1, 'days');
        // console.log(now);
        let day = now.clone();
        let startRange = null;
        let endRange = null;

        switch (duration) {
            case '1d': {
                startRange = now.clone().startOf('day').unix();
                endRange = now.clone().endOf('day').unix();
                break;
            }
            case '1m': {
                endRange = now.clone().endOf('day').unix();
                day = now.subtract(1, 'months')
                startRange = day.clone().startOf('day').unix();
                break;
            }
            case '3m': {
                endRange = now.clone().endOf('day').unix();
                day = now.subtract(3, 'months')
                startRange = day.clone().startOf('day').unix();
                break;
            }
            case '6m': {
                endRange = now.clone().endOf('day').unix();
                day = now.subtract(6, 'months')
                startRange = day.clone().startOf('day').unix();
                break;
            }
            case '12m': {
                endRange = now.clone().endOf('day').unix();
                day = now.subtract(12, 'months')
                startRange = day.clone().startOf('day').unix();
                break;
            }
            default: {
                endRange = now.clone().endOf('day').unix();
                day = now.subtract(6, 'days')
                startRange = day.clone().startOf('day').unix();
                break;
            }
        }
        if (endRange && startRange) {
            // console.log(startRange, endRange);
            setDurationRange([startRange * 1000, endRange * 1000])
            if (callFunction)
                handleCallFuelDataDefault(startRange * 1000, endRange * 1000);
        }

    }

    const onChangeRange = (range) => {
        if (range && range.length === 2)
            setDurationRange([range[0].startOf('day').unix() * 1000, range[1].endOf('day').unix() * 1000])
    }

    const handleCallFuelData = () => {
        if (durationRange && durationRange.length === 2)
            props.callFuelData(durationRange[0], durationRange[1]);
    }

    const handleReProcess = () => {
        // console.log(durationRange);
        if (durationRange && durationRange.length === 2)
            props.processDeviceDailyFuelDataInPeriod(props.device, durationRange[0], durationRange[1]);
    }

    const handleCallFuelDataDefault = (fromRange, toRange) => {
        // console.log('fromRange>>>', props.hasFuelSensor);
        if (fromRange && toRange)
            props.callFuelData(fromRange, toRange);
    }

    useEffect(() => {
        if (props.assetDeviceDailyFuelDataSuccess) {
            setPeriodProcessing(props.assetDeviceDailyFuelDataSuccess)
        } else {
            setPeriodProcessing(false)
        }
    }, [props.assetDeviceDailyFuelDataSuccess]);
    // useEffect(() => {
    //     console.log('hasFuelSensor>>>', props.hasFuelSensor);
    // }, [props.hasFuelSensor]);
    // useEffect(() => {
    //     console.log(props.selectedValue);
    // }, [props.selectedValue]);

    return (
        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', gap: 8 }}>
            <Select value={props.selectedValue} style={{ width: 120 }} size='small' placeholder="Period" onChange={handleSelectDurationChange}>
                <Option value="7d">7 Days</Option>
                <Option value="1m">1 Month</Option>
                <Option value="3m">3 Months</Option>
                <Option value="6m">6 Months</Option>
                <Option value="12m">12 Months</Option>
                <Option value="0">Custom</Option>
            </Select>
            {isCustomRange && (
                <RangePicker size='small' style={{ width: 220 }} onChange={onChangeRange} />
            )}
            <Select value={props.selectedGroup} style={{ width: 100 }} size='small' placeholder="Group by" onChange={processChangedGroup}>
                <Option value="d">Daily</Option>
                <Option value="w">Weekly</Option>
                <Option value="m">Monthly</Option>
                <Option value="y">Yearly</Option>
            </Select>
            <Button type="primary" onClick={handleCallFuelData} loading={props.loading} size='small' style={{ marginBottom: 0 }}>
                {props.loading ? '' : 'Apply'}
            </Button>
            <Button type="default" onClick={handleReProcess} disabled={periodProcessing} loading={props.loading} size='small' style={{ marginBottom: 0 }}>
                {(periodProcessing || props.loading) ? '' : 'Re-process'}
            </Button>
        </div>
    );
}

export default FuelReportInfo;
